import React from 'react';
import { cn } from '../../utils/cn';
interface PanelProps {
  title?: string;
  description?: string;
  action?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  bodyClassName?: string;
}
export function Panel({
  title,
  description,
  action,
  children,
  className,
  bodyClassName
}: PanelProps) {
  return <section className={cn('rounded-card border border-line bg-surface shadow-panel', className)} data-id="element-5254" data-mp="2kinqb6hpz8j7">
      {(title || action) && <header className="flex flex-wrap items-start justify-between gap-x-4 gap-y-2 border-b border-line px-5 py-4" data-id="element-5255" data-mp="2bjtz5vn5rad1">
          <div className="min-w-0" data-id="element-5256" data-mp="1wvz4i9plavxb">
            {title && <h2 className="text-h4 font-semibold text-ink" data-id="element-5257" data-mp="21tqw12mbog0z">{title}</h2>}
            {description && <p className="mt-1 text-body-sm text-ink-muted" data-id="element-5258" data-mp="21ro4uf9foguo">{description}</p>}
          </div>
          {action}
        </header>}
      <div className={cn('px-5 py-4 sm:px-6 sm:py-5', bodyClassName)} data-id="element-5259" data-mp="1stkkhma6pq4g">{children}</div>
    </section>;
}